module.exports = __webpack_public_path__ + "img/Niro_back_install.dcc0fd80.png";